import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { LookupValuesService } from '../../common/lookup-values.service';
import { DealService } from '../../services/DealService';
import { AccountService } from '../../services/AccountService';

@Injectable({
  providedIn: 'root'
})
export class DealGetDropDownOptionsResolverService implements Resolve<any>{

    constructor(private lookupvaluesservice: LookupValuesService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return forkJoin(
            this.lookupvaluesservice.GetDealTypeOptions(),
            this.lookupvaluesservice.GetPropertyTypeOptions(),
            this.lookupvaluesservice.GetUnitOfMeasurementTypeOptions(),
            this.lookupvaluesservice.GetCountryOptions(),
        );
    }
}

@Injectable({
    providedIn: 'root'
})
export class DealEditGetResolverService{

    constructor(private dealService: DealService) {

    }
    resolve(route: ActivatedRouteSnapshot) {
        let id = route.paramMap.get('id');
        return this.dealService.GetDealById(id,true);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DealGetResolverService {

    constructor(private dealService: DealService) {

    }
    resolve(route: ActivatedRouteSnapshot) {
        let id = route.paramMap.get('id');
        return this.dealService.GetDealById(id,false);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DealNoteGetResolverService {

    constructor(private dealService: DealService) {

    }
    resolve(route: ActivatedRouteSnapshot) {
        let id = route.paramMap.get('id');
        return this.dealService.GetDealNotesByDealId(id);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DealAdditionalCommunicationRecipientGetResolverService {

    constructor(private dealService: DealService) {

    }
    resolve(route: ActivatedRouteSnapshot) {
        let id = route.paramMap.get('id');
        return this.dealService.GetDealAdditionalComunnicationUsersByDealId(id);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DealViewGetDealsResolverService implements Resolve<any>{

    constructor(private dealService: DealService, private accountService: AccountService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.dealService.GetDealsByBrokerId(this.accountService.userValue.broker.Id, 0);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DealAdminDealsResolverService implements Resolve<any>{

    constructor(private dealService: DealService, private accountService: AccountService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.dealService.GetAdminDeals();
    }
}